"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskClassificationDescription = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.RiskClassificationDescription = {
    priority: 2,
    label: 'fields.payload.mor_group_answers.risk_classification_description.label',
    fallbackLabel: 'Please provide rationale behind not performing risk assessment and please help us understand how your organization currently assesses and manages the risk of money laundering without a formal risk scoring system?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.has_risk_classification', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.has_risk_classification === false
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.has_risk_classification === false
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
